import { render, staticRenderFns } from "./MiraBusinessDevelopment.vue?vue&type=template&id=09e6ee73&scoped=true&"
import script from "./MiraBusinessDevelopment.vue?vue&type=script&lang=ts&"
export * from "./MiraBusinessDevelopment.vue?vue&type=script&lang=ts&"
import style0 from "./MiraBusinessDevelopment.vue?vue&type=style&index=0&id=09e6ee73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e6ee73",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
